import { createSlice } from "@reduxjs/toolkit";
// ⚠️ Deep-imports the DESKTOP variant on purpose — hazard 6.
import { supportLogout, userLogout } from "../LoginSlice";
import { sharedInitialState, sharedReducers } from "./shared";
import type { SharedRegisterState } from "./shared";

export interface RegisterState extends SharedRegisterState {
   drk: string | null
  }

  const initialState: RegisterState = {
    ...sharedInitialState,
    drk: null
  };

export const registerSlice = createSlice({
    name : 'register',
    initialState,
    reducers : {
      ...sharedReducers,
      // The 3 below are web-only.
      updateRegisterSlice: (state, action) => {
        return action.payload;
      },
      setBusinessData: (state, action) => {
        state.users = action.payload;
      },
       setDrk: (state, action) => {
        state.drk = action.payload;
      }
    },
    // Both bodies are empty in the app source — the cases exist but reset nothing.
    extraReducers: (builder) => {
      builder
        .addCase(userLogout, (state) => {

        })
        .addCase(supportLogout, (state) => {

        });
    },
})

export const {
   getUsersList,
   getUsersListSuccess,
   getRegistrationData,
   requestRegistrationResponse,
   requestRegistrationKey,
   requestRegistrationKeyResponse,
   changePinRequest,
   changePinRequestResponse,
   resetChangePinFlag,
   registerFCMToken,
   updateRegisterSlice,
   setBusinessData,
   setDrk
  } = registerSlice.actions;
  export default registerSlice.reducer;
